import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpune() {



    const cardData = {

keyword: "Tempo Traveller On Rent in Pune",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Tempo Traveller On Rent in Pune for group travel, family trips, corporate outings, weddings, school tours, and outstation journeys. We provide well-maintained 9, 12, 15, and 17-seater Tempo Travellers with push-back seats, AC comfort, and experienced drivers for safe long-distance travel. With doorstep pickup across Pune, flexible rental packages, 24/7 support, and transparent pricing, we ensure a smooth and hassle-free group travel experience for every journey.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular weekend destinations near Pune, known for lush green valleys, waterfalls, foggy mountains, and scenic viewpoints. Tempo Traveller rentals are ideal for group trips, family outings, and corporate tours to enjoy monsoon beauty and short getaways together."
    },
    {
        title: "Mahabaleshwar Hill Station",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, and cool weather. It is perfect for group travel in Tempo Traveller, offering comfortable journeys for families, friends, and corporate teams exploring nature and sightseeing."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. Tempo Travellers are widely used for group darshan tours, allowing families and devotees to travel together comfortably for spiritual visits and blessings."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a major religious and cultural destination known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. It is a popular group travel location for spiritual tours, family trips, and corporate outings using Tempo Traveller rentals from Pune."
    },
    {
        title: "Goa Beach Tour",
        description:
            "Goa is a long-distance vacation destination famous for beaches, nightlife, and adventure activities. Tempo Traveller rentals are perfect for large groups, friends, wedding trips, and corporate vacations traveling from Pune to Goa."
    },
    {
        title: "Ashtavinayak Darshan Route",
        description:
            "The Ashtavinayak pilgrimage circuit covers eight sacred Ganpati temples across Maharashtra. Tempo Travellers are commonly booked for group spiritual tours, offering comfort and convenience for family religious journeys from Pune."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular group pilgrimage destination where Tempo Travellers provide safe and comfortable travel for devotees and families."
    },
    {
        title: "Alibaug Beaches",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. It is a popular group outing location for corporate trips, school tours, and family picnics using Tempo Traveller rentals from Pune."
    },
    {
        title: "Konkan Coastal Trip",
        description:
            "The Konkan coast including destinations like Ganpatipule, Diveagar, and Harihareshwar is a scenic travel route. Tempo Travellers are ideal for long group vacations, offering comfort and space for beach tours from Pune."
    },
    {
        title: "Aurangabad Heritage Circuit",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. It is a popular group heritage tour destination where Tempo Travellers are used for educational trips and family tours from Pune."
    }
],



services: [
{
name: "Tempo Traveller in Pune",
description: "Rising Cab Service offers Tempo Traveller in Pune for group travel, family tours, corporate trips, and outstation journeys. Our vehicles are spacious, well-maintained, AC equipped, and driven by professional chauffeurs ensuring safe and comfortable long-distance travel."
},
{
name: "17 Seater Bus on Rent in Pune Price",
description: "Get transparent 17 Seater Bus on Rent in Pune Price with Rising Cab Service. We provide affordable per km rates, flexible packages, and no hidden charges, making group travel budget-friendly and convenient for all occasions."
},
{
name: "17 Seater Tempo Traveller on Rent in Pune",
description: "Book 17 Seater Tempo Traveller on Rent in Pune for family trips, weddings, and corporate outings. Enjoy comfortable push-back seating, AC interiors, ample luggage space, and experienced drivers for safe travel."
},
{
name: "Tempo Traveller on Rent in Pune to Outstation",
description: "Rising Cab Service provides Tempo Traveller on Rent in Pune for Outstation trips to Goa, Shirdi, Mahabaleshwar, and all India routes. Enjoy safe highway driving, flexible stops, and comfortable group travel experience."
},
{
name: "Tempo Traveller Hire in Pune",
description: "Book Tempo Traveller Hire in Pune with professional drivers, clean vehicles, and affordable pricing. Ideal for school trips, corporate tours, weddings, and family vacations with complete travel support."
},
{
name: "Tempo Traveller on Rent in Hadapsar",
description: "Rising Cab Service offers Tempo Traveller on Rent in Hadapsar for local and outstation group travel. Get quick booking, reliable service, and well-maintained vehicles for all travel needs."
},
{
name: "Tempo Traveller Rent Per KM in Pune",
description: "We provide transparent Tempo Traveller Rent Per KM in Pune with competitive pricing based on distance, vehicle type, and travel duration. Perfect for both local and long-distance journeys."
},
{
name: "Tempo Traveller Rental Pune",
description: "Book Tempo Traveller Rental in Pune for group travel with AC comfort, spacious seating, and professional drivers. Ideal for family tours, corporate trips, and religious travel."
},
{
name: "Pune to Shirdi Tempo Traveller",
description: "Rising Cab Service offers Pune to Shirdi Tempo Traveller for comfortable pilgrimage travel. Enjoy safe driving, flexible timing, and spacious seating for family and group darshan trips."
},
{
name: "Pune to Mahabaleshwar Tempo Traveller",
description: "Book Pune to Mahabaleshwar Tempo Traveller for hill station group tours. Enjoy scenic travel, comfortable seating, and safe driving for a relaxing weekend getaway."
},
{
name: "Pune to Goa Tempo Traveller on Rent",
description: "Rising Cab Service provides Pune to Goa Tempo Traveller on Rent for group beach holidays. Travel comfortably with AC buses, experienced drivers, and smooth highway journeys."
},
{
name: "Luxury Tempo Traveller on Rent in Pune",
description: "Book Luxury Tempo Traveller on Rent in Pune for premium group travel experience with push-back seats, LED entertainment, AC comfort, and professional chauffeurs for weddings and corporate tours."
},
{
name: "Tempo Traveller in Pimpri Chinchwad",
description: "Get Tempo Traveller in Pimpri Chinchwad for local and outstation group travel. We provide quick booking, affordable rates, and reliable service for all travel requirements."
},
{
name: "Tempo Traveller in Hinjewadi Pune",
description: "Rising Cab Service offers Tempo Traveller in Hinjewadi Pune for IT companies, corporate groups, and family tours with safe and comfortable travel options."
},
{
name: "Tempo Traveller in Wakad Pune",
description: "Book Tempo Traveller in Wakad Pune for group outings, corporate travel, and family trips with clean vehicles, experienced drivers, and flexible booking options."
},
{
name: "Tempo Traveller in Baner Pune",
description: "Rising Cab Service provides Tempo Traveller in Baner Pune for weddings, events, and outstation tours with reliable service and comfortable seating arrangements."
},
{
name: "Tempo Traveller in Kharadi Pune",
description: "Book Tempo Traveller in Kharadi Pune for corporate and family group travel. Enjoy easy booking, professional drivers, and well-maintained AC vehicles."
},
{
name: "Family Tempo Traveller on Rent Pune",
description: "Rising Cab Service offers Family Tempo Traveller on Rent in Pune for safe and comfortable group travel with spacious seating and affordable pricing."
},
{
name: "Corporate Tempo Traveller Hire Pune",
description: "Book Corporate Tempo Traveller Hire in Pune for employee transport, office tours, and business travel with punctual service and professional chauffeurs."
},
{
name: "Cheap Tempo Traveller Pune",
description: "Get Cheap Tempo Traveller in Pune with Rising Cab Service offering budget-friendly rates without compromising on comfort, safety, and travel quality."
}
],

tableData: [
["Tempo Traveller in Pune","17 Seater Bus on Rent in Pune Price"],
["17 Seater Tempo Traveller on Rent in Pune","Tempo Traveller Hire in Pune"],
["Tempo Traveller on Rent in Pune to Outstation","Tempo Traveller Rental Pune"],
["Tempo Traveller Rent Per KM in Pune","Tempo Traveller on Rent in Hadapsar"],
["Pune to Shirdi Tempo Traveller","Pune to Goa Tempo Traveller on Rent"],
["Pune to Mahabaleshwar Tempo Traveller","Luxury Tempo Traveller on Rent in Pune"],
["Tempo Traveller in Hinjewadi Pune","Tempo Traveller in Wakad Pune"],
["Tempo Traveller in Baner Pune","Tempo Traveller in Kharadi Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Affordable Mini Bus on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable mini bus rental services in Pune for family trips, corporate events, school outings, weddings, pilgrimages, and group tours."
    },
    {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription: "Choose from 17 Seater, 20 Seater, 25 Seater, 32 Seater, and other mini bus options according to your group size and travel requirements."
    },
    {
        WhyChooseheading: "Perfect for Group Travel",
        WhyChoosedescription: "Our mini buses are ideal for family functions, company outings, educational tours, religious journeys, picnics, and sightseeing trips."
    },
    {
        WhyChooseheading: "AC and Non-AC Mini Bus Availability",
        WhyChoosedescription: "Customers can select both air-conditioned and non-air-conditioned mini buses depending on travel preferences and budget."
    },
    {
        WhyChooseheading: "Local and Outstation Mini Bus Service",
        WhyChoosedescription: "Mini buses are available for Pune city travel as well as outstation destinations including Mahabaleshwar, Lonavala, Shirdi, Nashik, Goa, Kolhapur, and Konkan tours."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Vehicle pickup and reporting services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our professional drivers ensure safe driving, punctual service, and comfortable transportation for all passengers."
    },
    {
        WhyChooseheading: "Best Choice for Corporate and Family Events",
        WhyChoosedescription: "Rising Cab Service is trusted for employee transportation, wedding guest travel, family gatherings, school trips, and group tourism."
    }
]
};

const faqData = [
    {
        question: "What seating capacities are available in mini buses?",
        answer: "We provide 17 Seater, 20 Seater, 25 Seater, 32 Seater, and other mini bus options based on group size."
    },
    {
        question: "Can I rent a mini bus for outstation trips from Pune?",
        answer: "Yes, mini buses are available for outstation destinations across Maharashtra and other states."
    },
    {
        question: "Are AC mini buses available for hire?",
        answer: "Yes, both AC and Non-AC mini buses are available according to customer requirements."
    },
    {
        question: "Can mini buses be booked for corporate events?",
        answer: "Yes, mini buses are frequently used for employee transportation, conferences, corporate outings, and business events."
    },
    {
        question: "Do you provide mini buses for wedding functions?",
        answer: "Yes, mini buses can be arranged for wedding guest transportation, family events, and special occasions."
    },
    {
        question: "Can schools and colleges hire mini buses?",
        answer: "Yes, mini buses are available for educational tours, industrial visits, picnics, and student excursions."
    },
    {
        question: "Are drivers included with the mini bus rental?",
        answer: "Yes, all mini bus rentals include experienced and professional drivers."
    },
    {
        question: "Can I book a mini bus for pilgrimage tours?",
        answer: "Yes, mini buses are widely used for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, and other religious tours."
    },
    {
        question: "Is advance booking recommended for mini bus rentals?",
        answer: "Yes, advance reservations are recommended during weekends, holidays, wedding seasons, and festival periods."
    },
    {
        question: "How can I book a Mini Bus on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mahesh Patil",
        feedback:
            "We hired a mini bus for our family trip to Mahabaleshwar. The vehicle was clean, spacious, and the journey was comfortable for everyone.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shweta Kulkarni",
        feedback:
            "Our company outing was managed perfectly with Rising Cab Service. The mini bus arrived on time, the driver was professional, and the travel experience was excellent.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Tempo Traveller on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/tempo-traveller-pune.jpg",
"description": "Book Tempo Traveller on Rent in Pune with Rising Cab Service for group travel, corporate tours, weddings, and outstation trips. Choose from 12, 17, 20, and 26 seater AC tempo travellers with experienced drivers for safe and comfortable journeys.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹24/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/tempo-traveller-on-rent-pune"
}
};






    return (
        <div>

<Helmet>
  <title>Tempo Traveller on Rent in Pune | 12–26 Seater Group Travel | +91 9272511548</title>

<meta
 name="description"
 content="Book Tempo Traveller on Rent in Pune for group travel, corporate tours, weddings, and outstation trips. Get 12 to 26 seater AC tempo travellers with professional drivers."
/>

<meta
 name="keywords"
 content="tempo traveller in pune, 17 seater tempo traveller on rent in pune, tempo traveller on rent pune, traveller bus on rent in pune, tempo traveller for outstation pune, 12 seater tempo traveller pune, 20 seater tempo traveller pune, 26 seater tempo traveller pune, group travel pune, tempo traveller hire pune, outstation tempo traveller pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravelleronrentinpune;